export default function () {
  return {
    menu: false,
    mini_menu: false,
    panel: null,
    filters: null,
    messenger: false,
    messenger_chat_id: null,
    messenger_unread_count: 0
  };
}
